import axios from 'axios';
import { emit } from './eventEmitter';

export function axiosGlobalInterceptor(error) {
  if (error?.response?.data?.code?.toLowerCase?.() === 'blocked') {
    emit('blocked', error?.response?.data);
  }
}

axios.interceptors.response.use(
    undefined,
    (error) => {
      axiosGlobalInterceptor(error);
      return Promise.reject(error);
    }
);
